import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import WarehosueForm from "./WarehouseForm";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { warehouseValidationForm } from "../../utils/validationSchemas";

const CreateWarehouse = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    control,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(warehouseValidationForm),
  });
  const { handleCreate, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <WarehosueForm
        clearErrors={clearErrors}
        errors={errors}
        register={register}
        setValue={setValue}
        getValues={getValues}
        control={control}
      />
    </FormLayout>
  );
};

export default CreateWarehouse;
